import styled from 'styled-components';
import { themeGet } from 'styled-system';
import PropTypes from 'prop-types';
import { COMMON, LAYOUT, TYPOGRAPHY } from '../constants';
const Link = styled.a.withConfig({
  displayName: "Link",
  componentId: "sc-1110ut1-0"
})(["", ";", ";", ";cursor:pointer;text-decoration:none;transition:color 0.3s;&:hover{color:", ";}"], COMMON, LAYOUT, TYPOGRAPHY, themeGet('colors.blue'));
Link.defaultProps = {
  color: 'black'
};
Link.propTypes = { ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  ...TYPOGRAPHY.propTypes,
  href: PropTypes.string.isRequired
};
Link.displayName = 'Link';
export default Link;